module.exports = __webpack_public_path__ + "static/media/home-3.e8242cc9.jpg";